import React from 'react';

import { TextContent } from '../../index';

export default () => (
  <TextContent>
    <ol>
      <li>Hold a CPCS Blue Competent Operator Card for the category which is within the 5 year grace period from the expiry date (can renew 3 months before the card expires).</li>
      <li>Pass the relevant Health, Safety and Environment test (either NOCN or CITB) within the last two years.</li>
      <li>Complete the relevant CPCS CPD e-Learning module per category.</li>
      <li>Demonstrate on-going practical operating experience through a choice of routes:</li>
    </ol>
    <ul>
      <li>
        Logbook (more information available on our website:
          {' '}
        <a href="https://cpcs.nocn.org.uk/cpcs/" target="_blank" rel="noopener noreferrer" className="external-link">
          <strong>cpcs.nocn.org.uk/cpcs</strong>
        </a>
        )
      </li>
      <li>On-Site Assessment</li>
      <li>CPCS Practical test</li>
      <li>SVQ or NVQ (if completed in the past 2 years)</li>
    </ul>
    <p>Completion of form F1/3 Application to Renew CPCS Competent Operator Card, to be submitted to the mailing address on the reverse of the application form.  There is no need to attach payment as the cost of processing the application is included in the CPCS Renewal test fee.</p>
    <p>A Blue Competent Operator Card will be issued for 5 years from expiry date of previous card.</p>
    <strong>Note:</strong>
    <p>
      Where SVQ or NVQ units relevant to a category being renewed have been achieved within the previous two years of the renewal date, the logbook or On-Site Assessment does not need to be undertaken in order to renew that category. Furthermore for this concession, the grouping of categories for NVQ and SVQ purposes does not apply.
    </p>
    <ul>
      <li>*   Categories added to an existing competent card within the previous two years of the card’s life are exempt from taking the renewal test for that category only. All remaining categories must meet the renewal criteria.</li>
      <li>*   The CPCS renewal test may be taken up to two years prior to card expiry, but the renewed card can only be applied for up to three months prior to the renewal date.</li>
    </ul>
    <p>
      Further detailed information regarding the renewal criteria can be found within the CPCS Scheme Booklet for Operators and can be downloaded from
      {' '}
      <a href="https://cpcs.nocn.org.uk/cpcs/" target="_blank" rel="noopener noreferrer" className="external-link"><strong>cpcs.nocn.org.uk/cpcs</strong></a>
    </p>
    <p>
      If you are unsure of which categories are currently held or if exemptions apply, please contact the CPCS Helpline on
      {' '}
      <a href="tel:+03009991177" className="external-link"><strong>0300 999 1177</strong></a>
    </p>
  </TextContent>
);
